import { Component, OnInit, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Cookies } from '../../class/cookies';
import { Service } from '../../class/service';

import { HomeComponent } from '../module/home/home.component';
import { BancosComponent } from '../module/archivo/contabilidad/bancos/bancos.component';
import { DiasContablesComponent } from '../module/archivo/contabilidad/dias-contables/dias-contables.component';
import { FormatoArchivoComponent } from '../module/archivo/formato-archivo/formato-archivo.component';
import { FormatoArchivo01Component } from '../module/archivo/formato-archivo01/formato-archivo01.component';
import { CargosComponent } from '../module/archivo/nomina/cargos/cargos.component';
import { ConceptosComponent } from '../module/archivo/nomina/conceptos/conceptos.component';
import { ParametrosNominaComponent } from '../module/archivo/nomina/parametros-nomina/parametros-nomina.component';
import { SeguridadSocialComponent } from '../module/archivo/nomina/seguridad-social/seguridad-social.component';
import { SubcodigoComponent } from '../module/archivo/subcodigo/subcodigo.component';
import { CentroCostoComponent } from '../module/contable/centro-costo/centro-costo.component';
import { ConfigUserSucursalComponent } from '../module/contable/config-user-sucursal/config-user-sucursal.component';
import { ConfigBalanceGeneralComponent } from '../module/contable/config-balance-general/config-balance-general.component';
import { ConfigEstadoResultadoComponent } from '../module/contable/config-estado-resultado/config-estado-resultado.component';
import { ConfigFuenteComponent } from '../module/contable/config-fuente/config-fuente.component';
import { CuentasComponent } from '../module/contable/cuentas/cuentas.component';
import { CuentasNiifGrupoComponent } from '../module/contable/cuentas-niif-grupo/cuentas-niif-grupo.component';
import { DepartamentoComponent } from '../module/contable/departamento/departamento.component';
import { FormaPagoComponent } from '../module/contable/forma-pago/forma-pago.component';
import { FormaPago01Component } from '../module/contable/forma-pago01/forma-pago01.component';
import { FuentesComponent } from '../module/contable/fuentes/fuentes.component';
import { MunicipioComponent } from '../module/contable/municipio/municipio.component';
import { PaisComponent } from '../module/contable/pais/pais.component';
import { ParametrosContabilidadComponent } from '../module/contable/parametros-contabilidad/parametros-contabilidad.component';
import { RelaBaconFormaPagoComponent } from '../module/contable/rela-bacon-forma-pago/rela-bacon-forma-pago.component';
import { SucursalComponent } from '../module/contable/sucursal/sucursal.component';
import { TerceroComponent } from '../module/contable/tercero/tercero.component';
import { TipoEgresoIngresoComponent } from '../module/contable/tipo-egreso-ingreso/tipo-egreso-ingreso.component';
import { TipoComprobanteComponent } from '../module/contable/tipo-comprobante/tipo-comprobante.component';
import { TipoDocumentoComponent } from '../module/contable/tipo-documento/tipo-documento.component';
import { YearsContablesComponent } from '../module/contable/years-contables/years-contables.component';
import { AutPagaduriaComponent } from '../module/libranza/aut-pagaduria/aut-pagaduria.component';
import { BaseDatosComponent } from '../module/libranza/base-datos/base-datos.component';
import { EscalaNovedadesComponent } from '../module/libranza/escala-novedades/escala-novedades.component';
import { EstadoCreditoComponent } from '../module/libranza/estado-credito/estado-credito.component';
import { InversionistaComponent } from '../module/libranza/inversionista/inversionista.component';
import { LibranzaParametrizacionComponent } from '../module/libranza/libranza-parametrizacion/libranza-parametrizacion.component';
import { PagaduriaComponent } from '../module/libranza/pagaduria/pagaduria.component';
import { TipoNcrVsUsuariosComponent } from '../module/libranza/tipo-ncr-vs-usuarios/tipo-ncr-vs-usuarios.component';
import { TipoNcrVsFormapagoComponent } from '../module/libranza/tipo-ncr-vs-formapago/tipo-ncr-vs-formapago.component';

declare var jQuery: any;
const totalView:number = 5;

@Component({
  selector: 'app-dash',
  templateUrl: './dash.component.html',
  styleUrls: ['./dash.component.css']
})
export class DashComponent implements OnInit {
	private data = {};
	private views:Array<any> = [];
	private viewsName: any = [];
	private name:string = "";
	private isOpenNav = true;
	private tabs__active:boolean = false;
	private navOpen:boolean = false;

  constructor(
    private cookies:Cookies,
    private service:Service,
    private router:Router, 
		private _elRef:ElementRef
  ) { }

  ngOnInit() {
	  this.data = this.cookies.getCookie('ChamUserObject');
	  this.name = "HOME";
	  this.views.push(HomeComponent);
	  this.viewsName.push({description: "Home",id: "home-component"});
	  
	  if(this.cookies.getCookie('ChamView') != undefined){
		  let cook:any = this.cookies.getCookie('ChamView');
		  if(cook.length > 1){
			  cook.forEach(element =>{
				  this.selectedView(JSON.stringify(element));
				});
				setTimeout(()=>{
					this.activateView(this.viewsName[1]["id"]);
					jQuery(this._elRef.nativeElement).find('.nav__header ul li a.active').click();
				});
			}
		}
  }
  onOpened(open:boolean){
		this.isOpenNav = open;
	}
	selectedView(view:string){
		if(this.viewsName.length -1 < totalView){
			this.processView(view);
		}
	}
	private processView(view:string){
		let view_ = JSON.parse(view);
		if(!this.isTheView(view_.id)){
			this.name = view_.id;
			switch(this.name){
				case "conta_banco-component":
				this.views.push(BancosComponent);
				break;
				case "dias_contables-component":
				this.views.push(DiasContablesComponent);
				break;
				case "formatoarchivo-component":
				this.views.push(FormatoArchivoComponent);
				break;
				case "formatoarchivo01-component":
				this.views.push(FormatoArchivo01Component);
				break;
				case "cargos-component":
				this.views.push(CargosComponent);
				break;
				case "conceptos-component":
				this.views.push(ConceptosComponent);
				break;
				case "parametros-nomina-component":
				this.views.push(ParametrosNominaComponent);
				break;
				case "seguridad-social-component":
				this.views.push(SeguridadSocialComponent);
				break;
				case "subcodigo-component":
				this.views.push(SubcodigoComponent);
				break;
				case "centrocosto-component":
				this.views.push(CentroCostoComponent);
				break;
				case "configusersucursal-component":
				this.views.push(ConfigUserSucursalComponent);
				break;
				case "configbalancegeneral-component":
				this.views.push(ConfigBalanceGeneralComponent);
				break;
				case "configestadosresultados-component":
				this.views.push(ConfigEstadoResultadoComponent);
				break;
				case "configuracionfuente-component":
				this.views.push(ConfigFuenteComponent);
				break;
				case "cuentas-component":
				this.views.push(CuentasComponent);
				break;
				case "cuentasniifgrupo-component":
				this.views.push(CuentasNiifGrupoComponent);
				break;
				case "departamento-component":
				this.views.push(DepartamentoComponent);
				break;
				case "formapago-component":
				this.views.push(FormaPagoComponent);
				break;
				case "formapago01-component":
				this.views.push(FormaPago01Component);
				break;
				case "fuentes-component":
				this.views.push(FuentesComponent);
				break;
				case "municipio-component":
				this.views.push(MunicipioComponent);
				break;
				case "pais-component":
				this.views.push(PaisComponent);
				break;
				case "parametroscontabilidad-component":
				this.views.push(ParametrosContabilidadComponent);
				break;
				case "rela-banco-formapago-component":
				this.views.push(RelaBaconFormaPagoComponent);
				break;
				case "sucursal-component":
				this.views.push(SucursalComponent);
				break;
				case "tercero-component":
				this.views.push(TerceroComponent);
				break;
				case "tipoegresoingreso-component":
				this.views.push(TipoEgresoIngresoComponent);
				break;
				case "tipodocumentos-component":
				this.views.push(TipoDocumentoComponent);
				break;
				case "yearscontables-component":
				this.views.push(YearsContablesComponent);
				break;
				case "autpagaduria-component":
				this.views.push(AutPagaduriaComponent);
				break;
				case "basededatos-component":
				this.views.push(BaseDatosComponent);
				break;
				case "escala-novedades-component":
				this.views.push(EscalaNovedadesComponent);
				break;
				case "escala-novedades-component":
				this.views.push(EscalaNovedadesComponent);
				break;
				case "estadocredito-component":
				this.views.push(EstadoCreditoComponent);
				break;
				case "inversionista-component":
				this.views.push(InversionistaComponent);
				break;
				case "libranzaparametrizacion-component":
				this.views.push(LibranzaParametrizacionComponent);
				break;
				case "pagaduria-component":
				this.views.push(PagaduriaComponent);
				break;
				case "tiponcrvdusuarios-component":
				this.views.push(TipoNcrVsUsuariosComponent);
				break;
				case "tiponcrvsformapago-component":
				this.views.push(TipoNcrVsFormapagoComponent);
				break;
				case "tipocomprobante-component":
				this.views.push(TipoComprobanteComponent);
				break;
				
			}
			this.viewsName.push({description: view_.description, id: view_.id });
			this.cookies.removeCookie('ChamView');
			this.cookies.setCookie('ChamView',this.viewsName);
			this.activateView(view_.id);
			
		}
	}
	private isTheView(view:string) : boolean{
		let b:boolean = false;
		this.viewsName.forEach(element => {
			if(element["id"] == view){
				b = true;
			}					
		});
		return b;
	}
	private activateView(view:string):void{
		this.name = view;
		jQuery(this._elRef.nativeElement).find(".win__container .component").each((index,item) => {
			if(jQuery(item).attr("id") == this.name){
				jQuery(item).parent().parent().parent().css({ display: "block"});
			}else{
				jQuery(item).parent().parent().parent().css({ display: "none"});
			}
		});
	}
	private remmoveView(id:string):void{
		let _id = id;
		let key:number = -1;
		this.viewsName.forEach((element,index) => {
			if(element["id"] == _id){
				key = index;
			}					
		});
		if(key > -1){
			this.viewsName.splice(key, 1);
			this.views.splice(key, 1);
		}
		if(_id == this.name){
			if(key-1 < this.viewsName.length){
				this.activateView(this.viewsName[key-1]["id"]);
			}else{
				this.activateView(this.viewsName[key]["id"]);
			}
		}
		
		if(this.viewsName.length == 1){
			this.name = "home-component";
			this.activateView(this.name);
		}
		this.cookies.removeCookie('ChamView');
		this.cookies.setCookie('ChamView',this.viewsName);
	}
	Logout(){
		this.cookies.removeCookie('ChamUserObject');
		this.cookies.removeCookie('ChamView');
		let link = ['/login'];
		this.router.navigate(link);
	}

}



// WEBPACK FOOTER //
// ./src/app/component/dash/dash.component.ts